import axios from 'axios'
import { getLocalStorageToken, setLocalStorageToken } from './components/auth/tokenStorage'
import config from './config'

const instance = axios.create({
  baseURL: `${config.baseApiUrl}/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

instance.interceptors.request.use(
  (config) => {
    const token = getLocalStorageToken()
    if (!config?.headers) {
      throw new Error(`Expected 'config' and 'config.headers' not to be undefined`)
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

const ignoredUrl = (url: string) =>
  ['/criipto/authenticate', '/users/refresh-token'].filter((u) => u.indexOf(url) !== -1)?.length > 0

instance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config
    const token = getLocalStorageToken()

    if (!ignoredUrl(originalConfig.url) && err.response) {
      if (err.response.status === 401 && !originalConfig._retry) {
        // Access Token was expired
        originalConfig._retry = true
        try {
          const rs = await instance.post('/users/refresh-token', {
            token,
          })
          setLocalStorageToken(rs.data.token)
          return instance(originalConfig)
        } catch (_error) {
          // if error occured during refresh token, it means session has been expired and need to redirect to login screen
          setLocalStorageToken('')
          window.location.href = '/'
          return Promise.reject(_error)
        }
      }
    }
    return Promise.reject(err)
  },
)

export default instance
